/** Ids of `fulfillment.transfer_order_cancel_reason`, seeded by migration 20261005120000. */
export var TransferOrderCancelReason;
(function (TransferOrderCancelReason) {
    TransferOrderCancelReason[TransferOrderCancelReason["NO_LONGER_NEEDED"] = 1] = "NO_LONGER_NEEDED";
    TransferOrderCancelReason[TransferOrderCancelReason["WRONG_DETAILS"] = 2] = "WRONG_DETAILS";
    TransferOrderCancelReason[TransferOrderCancelReason["STOCK_UNAVAILABLE"] = 3] = "STOCK_UNAVAILABLE";
    TransferOrderCancelReason[TransferOrderCancelReason["DUPLICATE"] = 4] = "DUPLICATE";
    TransferOrderCancelReason[TransferOrderCancelReason["OTHER"] = 5] = "OTHER";
})(TransferOrderCancelReason || (TransferOrderCancelReason = {}));
//# sourceMappingURL=transfer-order-cancel-reason.js.map